export default {
  state: {
    dataList: [
      // {
      //   id: '1',
      //   title: '寻求人员管理数字化应用',
      //   dockingParty: '太原理工大学',
      //   text: '主要从事中药饮片加工，员工上下班通过指纹打卡，经常性打不上，且无法一键生成报表，需要进行针对性提高。',
      //   html: ``,
      //   deadline: '2023-10-01',
      //   time: '',
      //   tags: "技术需求,产品需求,功能改造需求,成功需求,外协代工需求,企业诊断需求",
      //   status: 1
      // },
      // {
      //   id: '2',
      //   title: '供应商管理系统需求',
      //   dockingParty: '太原科技大学',
      //   text: '公司希望采购供应商管理系统，能够实现供应商端管理和物流信息传递,供应商生命周期管理,采购合同管理,质量管理,寻源管理,电子商城目录等；能够对接SAP系统财务模块WM模块,WMS系统,MES系统实现业务协同，采购数据分析及采购成本降低支持。',
      //   html: ``,
      //   deadline: '2023-07-28',
      //   time: '',
      //   tags: "技术需求,产品需求,功能改造需求",
      //   status: 2
      // },
      // {
      //   id: '3',
      //   title: '能耗监测系统需求',
      //   dockingParty: '海纳实业控股集团有限公司',
      //   text: '希望通过对车间,生产工艺,生产设备等能耗使用情况进行分析，建立能耗计算模型，对未来企业能耗趋势进行预测分析。',
      //   html: ``,
      //   deadline: '2023-09-28',
      //   time: '',
      //   tags: "技术需求,产品需求,功能改造需求,外协代工需求",
      //   status: 3
      // },
      // {
      //   id: '4',
      //   title: '希望对接纯信用贷款，缓解目前公司生产压力',
      //   dockingParty: '山西建设投资集团有限公司',
      //   text: '业务需要，近期需大量购入原材料满足订单量，急需资金缓解日常生产压力。',
      //   html: ``,
      //   deadline: '2023-09-28',
      //   time: '',
      //   tags: "外协代工需求",
      //   status: 1
      // },
      // {
      //   id: '5',
      //   title: '高盐废水蒸发除盐高校技术',
      //   dockingParty: '太原工业大学',
      //   text: '寻求日处理30吨高盐制药废水，COD在400以下处理技术方案。',
      //   html: ``,
      //   deadline: '2023-09-28',
      //   time: '',
      //   tags: "技术需求,功能改造需求",
      //   status: 1
      // }
    ]
  },
}
